<template>
    <div class="create-new-employer">
        <div class="row">
          <amf-input label="Company Name" v-model="name" :columns="2" :validator="$v.name"></amf-input>
          <amf-format-input label="Tax ID" v-model="federalTaxId" format="__-_______" :validator="$v.federalTaxId"></amf-format-input>
        </div>
        <div class="row">
          <amf-datepicker label="Plan Start Date" :hideCalendar="true" v-model="planStartDate" :validator="$v.planStartDate"></amf-datepicker>
          <amf-input label="Number of Eligible Employees" v-model="numberOfEligibleEmployees" :validator="$v.numberOfEligibleEmployees"></amf-input>
        </div>
        <label class="amf-label mt-1">Service Selection</label>
        <div class="row" v-for="(s, index) in serviceTypes" :key="index">
            <div class="col-6" v-for="(type, i) in s" :key="i">
                <amf-checkbox :label="type.description" v-model="type.selected" :disabled="serviceTypeDisabled(type)" />
            </div>
        </div>
    </div>
</template>

<script>
    import router from '../router/index'
    import { orderFormItemDisabled } from './OrderServices.vue'

    export default {
        data() {
            return {
                title: 'Create New Employer',
                name: null,
                planStartDate: null,
                federalTaxId: null,
                numberOfEligibleEmployees: null,
                serviceTypes: []
            }
        },
        async created() {
            let serviceTypes = await romeApi.get('config/product-definition');
            serviceTypes = serviceTypes.map(s => {
                return {
                    orderFormCode: s.orderFormCode,
                    description: s.description,
                    selected: false
                }
            });

            this.serviceTypes = _.chunk(serviceTypes, 6);
        },
        methods: {
            ...amfx.map("actionItems", "loadAssigned"),
            serviceTypeDisabled(item) {
                let services = _.flatten(this.serviceTypes)
                    .filter(s => s.selected).map(s => s.orderFormCode);
                return orderFormItemDisabled(services, item.orderFormCode);
            },
            async save() {
                let products = _.flatten(this.serviceTypes)
                    .filter(s => s.selected).map(s => s.orderFormCode);

                let dto = {
                    name: this.name,
                    planStartDate: this.planStartDate,
                    numberOfEligibleEmployees: this.numberOfEligibleEmployees,
                    products
                };
                let result = await romeApi.post(`employer/create`, dto);
                await this.loadAssigned();
                if(result && result.employerId) {
                    router.push(`/employer/${result.employerId}/general`);
                }
            },
            validate() {
                let services = _.flatten(this.serviceTypes)
                    .filter(s => s.selected).map(s => s.orderFormCode);

                if(!services.length) {
                    return "Please select at least one product";
                }
                return;
            }
        },
        validations() {
            return {
                name: v.build(v.required()),
                planStartDate: v.build(v.required(), v.date()),
                federalTaxId: v.build(v.taxId()),
                numberOfEligibleEmployees: v.build(v.required(), v.integer())
            }
        }
    }
</script>

<style lang="scss" scoped>
    .create-new-employer {

    }
</style>



// WEBPACK FOOTER //
// src/employer/CreateNewEmployer.vue